
<template>
    <!-- 商品列表 -->
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form layout="inline" @submit="handleSearch" :autoFormCreate="
                (form) => {
                    this.searchForm = form;
                }
            ">
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="商品名称" fieldDecoratorId="name">
                            <a-input placeholder="商品名称" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="SKU" fieldDecoratorId="sku">
                            <a-input placeholder="sku" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="供应商" fieldDecoratorId="supplier_id">
                            <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                                <a-select-option v-for="item in suppliers" :key="item.id">{{
                                    item.name
                                }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="分类" fieldDecoratorId="goods_category_id">
                            <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                                <a-select-option v-for="item in categories" :key="item.id">{{
                                    item.name
                                }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="库存为0" fieldDecoratorId="is_stock_zero">
                            <a-select placeholder="请选择" allowClear>
                                <a-select-option :key="0">全部</a-select-option>
                                <a-select-option :key="1">是</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <span class="table-page-search-submitButtons">
                            <a-button type="primary" htmlType="submit">查询</a-button>
                            <a-divider type="vertical" />
                            <a-button type="primary" @click="handleAdd">新增</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <s-table ref="table" size="default" :columns="columns" :data="loadData">
            <template slot="roleContent" slot-scope="text">
                {{ text | roleNameFFilter }}
            </template>
            <template slot="lockedContent" slot-scope="text">
                {{ text ? "不可用" : "可用" }}
            </template>
            <template slot="retail_price" slot-scope="text">
                {{text > 0? text /100:"--"}}
            </template>
            <template slot="branch_name" slot-scope="text, record">
                <span v-if="record.type == 0 || record.type == 1">{{ text }}</span>
                <span v-else>{{ text + "," +
                    record.purchase_order_move_record.map(item => item.branch_name).join(",") }}</span>
            </template>
            <template slot="action" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a @click="setStock(record)">管理库存</a>
                    <a-divider type="vertical" />
                    <a @click="edit(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a @click="gotoLog(record)">操作日志</a>
                    <a-divider type="vertical" />
                    <a-popconfirm
                        title="确定删除此商品吗？"
                        @confirm="handleDelete(record)"
                        okText="是"
                        cancelText="否"
                        >
                        <a>删除</a>
                    </a-popconfirm>
                </div>
            </template>
        </s-table>
        <a-modal title="库存管理" :visible.sync="modal.visible" @ok="handleOk" @cancel="modal.visible = false">
            <a-form layout="inline">
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="商品状态">
                            <a-radio-group v-model="modal.shelf_status">
                                <a-radio :value="true">上架</a-radio>
                                <a-radio :value="false">下架</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="当前库存">
                            {{ modal.before_stock_num }}
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="调整库存为">
                            <a-input-number v-model="modal.num" :min="0" placeholder="请输入调整后数量" style="width:140px"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <div>备注：</div>
                        <a-input v-model="modal.remark" type="textarea" :rows="4" />
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>
    </a-card>
</template>
<script>
import STable from "@/components/table/";
import { gettMallGoodsSkus, updateMallGoodsSkuStock,deleteMallGoodsSku } from "@/api/mall";
import { getSupplierList } from "@/api/supplier";
import { getCategoryList } from '@/api/category'

export default {
    components: {
        STable
    },
    data() {
        return {
            modal: {
                visible: false,
                id: 0,
                shelf_status: false,
                before_stock_num: 0,
                num: 0,
                remark: '',
            },
            searchForm: null,
            categories:[],
            columns: [
                {
                    title: "商品名称",
                    dataIndex: "name",
                    key: "name",
                },
                {
                    title: "SPU",
                    dataIndex: "spu",
                    key: "spu",
                },
                {
                    title: "规格",
                    dataIndex: "specification",
                    key: "specification",
                },
                {
                    title: "SKU",
                    dataIndex: "sku",
                    key: "sku",
                },
                {
                    title: "供应商",
                    dataIndex: "supplier_name",
                    key: "supplier_name",
                },
                {
                    title:"分类",
                    dataIndex:"goods_category_name",
                    key:"goods_category_name",
                },
                {
                    title: "兑换价",
                    dataIndex: "exchange_price",
                    key: "exchange_price",
                },
                {
                    title: "购买价",
                    dataIndex: "retail_price",
                    key: "retail_price",
                    scopedSlots: { customRender: "retail_price" }
                },
                {
                    title: "成本价",
                    dataIndex: "cost_price",
                    key: "cost_price",
                },
                {
                    title: "库存数量",
                    dataIndex: "stock_num",
                    key: "stock_num",
                },
                {
                    title: "操作",
                    dataIndex: "action",
                    key: "action",
                    width: 200,
                    scopedSlots: { customRender: "action" }
                }
            ],
            suppliers: [],
            loadData: (params) => {
                return gettMallGoodsSkus(Object.assign(params, this.queryParam)).then(
                    (res) => res
                );
            },
        };
    },
    methods: {
        getCategoryList: function () {
            getCategoryList({ page_size: 10000 }).then(res => {
                this.categories = res.list
            })
        },
        gotoLog(record){
            console.log(record)
            this.$router.push({
                path: `/mall/goods/sku/${record.id}/log`,
            })
        },
        handleOk() {
            if (this.modal.num < 0) {
                this.$message.error('库存数量不能小于0')
                return
            }
            if (this.modal.remark.trim() == '') {
                this.$message.error('请填写备注')
                return
            }
            this.modal.visible = false
            updateMallGoodsSkuStock({
                id: this.modal.id,
                num: this.modal.num,
                remark: this.modal.remark,
                shelf_status: this.modal.shelf_status,
            }).then(res => {
                this.$message.success('操作成功')
                this.modal.visible = false
                this.$refs.table.refresh()
            })
        },
        setStock(record) {
            this.modal = {
                visible: true,
                id: record.id,
                shelf_status: record.shelf_status,
                before_stock_num: record.stock_num,
                num: record.stock_num,
                remark: '',
            }
        },
        getSupplierList() {
            getSupplierList().then(res => {
                this.suppliers = res.list
            })
        },
        handleSearch(e) {
            e.preventDefault();
            this.queryParam = {
                name: this.searchForm.getFieldValue("name"),
                sku: this.searchForm.getFieldValue("sku"),
                supplier_id: this.searchForm.getFieldValue("supplier_id"),
                is_stock_zero: this.searchForm.getFieldValue("is_stock_zero"),
                goods_category_id: this.searchForm.getFieldValue("goods_category_id"),
            };
            this.$refs.table.refresh();
        },
        edit(record) {
            this.$router.push({
                path: `/mall/goods/${record.mall_goods_id}/edit`
            });
        },
        handleChange(record) {
            // this.$router.push({
            //     path: "/mall/goods/edit",
            //     query: {
            //         id: record.id
            //     }
            // });
        },
        handleAdd() {
            this.$router.push({
                path: "/mall/goods/create"
            });
        },
        handleDelete(record) {
            console.log(record)
            deleteMallGoodsSku(record.id).then(res => {
                this.$message.success('删除成功')
                this.$refs.table.refresh()
            })
        }
    },
    created() {
        this.getSupplierList()
        this.getCategoryList()
    }
}
</script>